package com.downdogapp.client

data class CommonUri(val path: String) {

  override fun toString() = path
}
